type SearchCombinationType =
  | 'manufacturer'
  | 'model'
  | 'bodyType'
  | 'usageType';

export class SearchCombination {
  public static manufactureFromList(
    manufacturer: string,
    values: string[],
    translations: string[],
    type: SearchCombinationType
  ): SearchCombination[] {
    return values.map(
      (v, i) => new SearchCombination(manufacturer, v, translations[i], type)
    );
  }
  public manufacturer: string;
  public value: string;
  public translation: string;
  public hash: string;
  public displayValue: string;
  public type: SearchCombinationType;

  constructor(
    manufacturer: string,
    value: string = '',
    translation: string = '',
    type: SearchCombinationType
  ) {
    this.manufacturer = manufacturer;
    this.value = value;
    this.translation = translation;
    this.type = type;
    this.hash = `${manufacturer} - ${value}`;
    this.displayValue = `${manufacturer} ${translation}`.trim();
  }

  public toString() {
    return this.displayValue;
  }
}
